// src/Services/groqClient.js
//
// Thin wrapper around the groqChatCompletion Cloud Function (functions/aiProxy.js).
// The Groq API key lives only in that function's environment — no client
// service should ever import the Groq SDK or hold the key directly.
import { getFunctions, httpsCallable } from 'firebase/functions';
import authService from './authService';

let cachedFn = null;
function getGroqChatCompletionFn() {
  if (!cachedFn) {
    cachedFn = httpsCallable(getFunctions(), 'groqChatCompletion');
  }
  return cachedFn;
}

/**
 * @param {Object} params - { messages, model?, temperature?, max_tokens?, response_format?, reasoning_effort? }
 * @returns {Promise<string>} the completion's message content
 */
export async function groqChatCompletion(params) {
  // Solo play never touches account/room services, so nothing else on that
  // path guarantees a Firebase Auth session exists — without this, a fresh
  // guest's very first AI call would be rejected as unauthenticated and
  // silently fall back to length-based scoring. ensureAuthenticated() is a
  // no-op once a session exists, so this costs nothing on every other path.
  await authService.ensureAuthenticated();

  const fn = getGroqChatCompletionFn();
  const result = await fn(params);
  return result.data?.content;
}
